/* eslint-disable no-param-reassign */
import { Button } from 'react-bootstrap';
import { useDraggable } from 'react-use-draggable-scroll';
import { useRef } from 'react';
import { UseFormSetValue, UseFormGetValues } from 'react-hook-form';
import { ChatMessageInput } from '@website/types/graphqlOperations';
import cannedResponses from './cannedResponses';

/**
 * Shows canned responses for hosts that they can automatically add in
 * to the referenced textBox
 */
export default function CannedResponseOptions({
  setValue,
  getValues,
  textAreaRef,
}: {
  setValue: UseFormSetValue<ChatMessageInput>;
  getValues: UseFormGetValues<ChatMessageInput>;
  textAreaRef: HTMLTextAreaElement;
}) {
  const ref = useRef();
  const { events } = useDraggable(ref);

  return (
    <div
      style={{
        overflowX: 'auto',
        whiteSpace: 'nowrap',
        scrollSnapType: 'x',
        overscrollBehaviorX: 'contain',
      }}
      className="mb-2 mt-1 mb-md-3 mt-md-0 d-flex scrollbar-hide"
      {...events}
      ref={ref}
    >
      {cannedResponses.map((cannedResponse) => (
        <Button
          variant="outline-primary"
          className="fw-normal rounded-pill text-capitalize me-2 d-inline-block"
          style={{ letterSpacing: '1px' }}
          size="sm"
          key={cannedResponse.buttonText}
          onClick={() => {
            const currentText = getValues('text');
            const newText = currentText
              ? `${currentText} ${cannedResponse.message}`
              : cannedResponse.message;
            setValue('text', newText, { shouldValidate: true });

            // Set the height
            textAreaRef.style.height = 'auto';
            const offset = textAreaRef.offsetHeight - textAreaRef.clientHeight;
            textAreaRef.style.height = `${textAreaRef.scrollHeight + offset}px`;

            // Scroll to the bottom of the text area
            textAreaRef.scrollTop = textAreaRef.scrollHeight + offset;
          }}
        >
          {cannedResponse.buttonText}
        </Button>
      ))}
    </div>
  );
}
